import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import moment from 'moment';

export class FinancialTransactionReport  extends  AbstractReport {

    static get TAX() {

        return 'tax';
    }

    static get FEE() {

        return 'fee';
    }

    static get TAX_FEE() {

        return 'tax-fee';
    }

    static get ITEM() {

        return 'item';
    }

    static get ROOM() {

        return 'room-revenue';
    }

    static get ADJUST() {

        return 'adjust';
    }

    static get PAYMENT() {

        return 'payment';
    }

    static get REFUND() {

        return 'refund';
    }

    static get BANK() {

        return 'bank-transfer';
    }

    static get CUSTOM() {

        return 'custom';
    }

    static get VISA_MASTER_TYPE() {

        return 'credit-card-type';
    }

    static get NEW_CARD() {

        return 'new-credit-card';
    }

    static get VISA_ID() {

        return 1;
    }

    static get MASTERCARD_ID() {

        return 2;
    }

    static get ALL_CARD_ID() {

        return 'credit-card';
    }

    static get ALL() {

        return 'all';
    }

    getCheckOut(value) {

        if (this.same_day_checkout) {

            return moment(value, 'DD/MM/YYYY').subtract(1, 'day').format('DD/MM/YYYY');
        }

        return value;
    }

}
AccessorsMutatorsDecorator(
    'username',
    'created_at_tz',
    'room_name',
    'name',
    'reservation_ident',
    'transaction_code',
    'description',
    'check_in',
    'check_out',
    'reservation_status',
    'reservation_status_int',
    'notes',
    'quantity',
    'debit',
    'credit',
    'debit_formatted',
    'credit_formatted',
    'is_house_account',
    'house_account_id',
    'cash_drawer',
    'cash_drawer_id',
    'guest_id',
    'is_refund',
    'is_void',
    'type',
    'same_day_checkout',
    'paid_out_amount',
    'paid_out_amount_formatted',
    'collected_amount',
    'collected_amount_formatted',
    'balance',
    'balance_formatted',
    'latest_sd_payment_voucher',
    'latest_sd_refund_voucher',
    // Added missing properties from dailyTransaction API, avoiding duplicates
    'room', // room number or code (not a duplicate of room_name)
    'accommodation_status',
    'nights',
    'amount',
    'rent',
    'extras',
    'penalties',
    'remaining',
    'paid',
    'refund',
    'security_deposit',
    'currency',
    'currency_format',
    'property_id',
    'property_name',
    'payment_option_id',
    'payment_option_name',
    'payment_option_type',
    'user_id',
    'user_name',
    'voucher_id',
    'voucher_type',
    'voucher_number',
    'voucher_date',
    'item_category_id',
    'item_category_name',
    'item_id',
    'item_name',
    'addon_id',
    'addon_name',
    'tax_fee_id',
    'tax_fee_name',
    'penalty_type_id',
    'penalty_type_name',
    'house_account_name'
)(FinancialTransactionReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/financial/transactions-report.model.js